import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BusquedaTesoroResultadoRondaPage } from './busqueda-tesoro-resultado-ronda';

@NgModule({
  declarations: [
    BusquedaTesoroResultadoRondaPage,
  ],
  imports: [
    IonicPageModule.forChild(BusquedaTesoroResultadoRondaPage),
  ],
})
export class BusquedaTesoroResultadoRondaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro-resultado-ronda/busqueda-tesoro-resultado-ronda.module.ts